export default function MarkdownCell({ cell }) {
  return (
    <div className="pylab-markdown-cell">
      <div
        className="pylab-markdown-body"
        dangerouslySetInnerHTML={{ __html: cell.content }}
      />
    </div>
  );
}
